import { render } from "./Sarmaya.vue?vue&type=template&id=0212c540&scoped=true"
import script from "./Sarmaya.vue?vue&type=script&lang=js"
export * from "./Sarmaya.vue?vue&type=script&lang=js"

import "./Sarmaya.vue?vue&type=style&index=0&id=0212c540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212c540"]])

export default __exports__